"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const Button_1 = require("./Button");
require("./completion");
const store_1 = require("./store");
const flex_scss_1 = __importDefault(require("./styles/flex.scss"));
const store_view_scss_1 = __importDefault(require("./styles/store-view.scss"));
function StoreView({}) {
    return (React.createElement(React.Fragment, null,
        React.createElement("h1", null, "STORE VIEW"),
        React.createElement(Installer, { needPayment: false })));
}
exports.StoreView = StoreView;
function Installer({ needPayment }) {
    const dispatch = react_redux_1.useDispatch();
    const onClick = React.useCallback(() => {
        dispatch(store_1.actions.setEditorMode(store_1.EditorMode.Code));
    }, []);
    return (React.createElement("div", { className: store_view_scss_1.default.installer },
        React.createElement("div", { className: classnames_1.default(store_view_scss_1.default.header, flex_scss_1.default.horizontal) },
            React.createElement("img", { src: "https://assets.hackforplay.xyz/img/93a1462a4800cccde0887f580ef46298.png", alt: "" }),
            React.createElement("h2", { className: store_view_scss_1.default.name }, "ASSET NAME"),
            React.createElement("span", { className: store_view_scss_1.default.paid }, "PAID ITEM"),
            React.createElement("img", { src: "https://i.gyazo.com/476dade56d5b2c344a83de22d66a7d17.gif", alt: "", className: store_view_scss_1.default.gif })),
        React.createElement("div", { className: store_view_scss_1.default.description }, "ASSET DESCRIPTION ASSET DESCRIPTION ASSET DESCRIPTION ASSET DESCRIPTION"),
        React.createElement(Button_1.IconButton, { name: "add", disabled: needPayment, lg: true, primary: true, onClick: onClick }, "Install to the game"),
        needPayment ? (React.createElement(React.Fragment, null,
            React.createElement("h2", null, "How can I use this item?"),
            React.createElement("div", { className: store_view_scss_1.default.description }, "Join paid plan to get all items now"),
            React.createElement(Button_1.IconButton, { name: "open_in_new", lg: true, accent: true }, "Get this item"))) : null));
}
exports.Installer = Installer;
